module.exports = __webpack_public_path__ + "media/images/logo2-490bb6838c108cf9e9b17a6145025af6.png";